export default {"src":"/_next/static/media/grundriss-schwarz-weiß.9c3c0b80.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};